import { EventEmitter, Injectable, Optional, SkipSelf } from '@angular/core';

import { throwIfAlreadyLoaded } from '../pzCore/module-import-guard';
import { MessageModel } from './message.model';
import { Event } from '@angular/router';
import { DynamicComponentItem } from '../dynamic-component-loader/dynamic-component-item';

export enum MsgType {
    error = 'éè¯¯',
    success = 'æä½æå',
    info = 'æ³¨æ',
    warning = 'è­¦å',
}

@Injectable()
export class MessageService {

    public readonly loadingSubject: EventEmitter<boolean> = new EventEmitter<boolean>();
    public readonly lockedSubject: EventEmitter<boolean> = new EventEmitter<boolean>();
    public readonly configSubject: EventEmitter<boolean> = new EventEmitter<boolean>();
    public readonly growlSubject: EventEmitter<MessageModel> = new EventEmitter<MessageModel>();
    public readonly confirmSubject: EventEmitter<{ method: string, confirm: any } | null>
        = new EventEmitter<{ method: string, confirm: any } | null>();
    public readonly routerSubject: EventEmitter<Event> = new EventEmitter<Event>();
    public readonly customSubject: EventEmitter<any> = new EventEmitter<any>();
    public readonly modalSubject: EventEmitter<any> = new EventEmitter<any>();
    public readonly drawerSubject: EventEmitter<any> = new EventEmitter<any>();
    public routerEvent: { urlAfterRedirects: string };

    public constructor(@Optional() @SkipSelf() parent: MessageService) {
        this.routerSubject.subscribe(
            (event) => this.routerEvent = event
        );
        throwIfAlreadyLoaded(parent, 'MessageService');
    }

    /**
     *  MUST call hide.
     *  @see /src/app/core/loading.component.ts
     */
    public showLoading() {
        this.loadingSubject.emit(false);
    }

    public hideLoading() {
        this.loadingSubject.emit(true);
    }
    public configShow() {
        this.configSubject.emit(true);
    }
    public configHidden() {
        this.configSubject.emit(false);
    }
    public lockPage(status: boolean) {
        this.lockedSubject.emit(status);
    }
    public success(detail?: string, summary: string = 'success') {
        const content: MessageModel = {
            type: summary,
            title: MsgType[summary],
            content: detail
        };
        this.growlSubject.emit(content);
    }

    public info(detail: string, summary: string = 'info') {
        const content: MessageModel = {
            type: summary,
            title: MsgType[summary],
            content: detail
        };
        this.growlSubject.emit(content);
    }

    public warn(detail: string, summary: string = 'warning') {
        const content: MessageModel = {
            type: summary,
            title: MsgType[summary],
            content: detail
        };
        this.growlSubject.emit(content);
    }

    public error(detail: string, summary: string = 'error') {
        const content: MessageModel = {
            type: summary,
            title: MsgType[summary],
            content: detail
        };
        this.growlSubject.emit(content);
    }

    public confirm(confirm: any) {
        this.confirmSubject.emit({method: 'confirm', confirm});
    }

    public modal(option: any) {
        this.modalSubject.emit(option);
    }

    public drawer(option: any) {
        this.drawerSubject.emit(option);
    }

    public customInsert(item?: DynamicComponentItem | null) {
        this.customSubject.emit(item);
    }
}
